import { useCallback } from "react";

interface UseTableSortingProps {
  onSort?: (column: string) => void;
  sortBy?: string;
  sortDirection?: "ASC" | "DESC";
}

export function useTableSorting({
  onSort,
  sortBy,
  sortDirection,
}: UseTableSortingProps) {
  const handleSortClick = useCallback(
    (column: string) => {
      if (onSort) {
        onSort(column);
      }
    },
    [onSort]
  );

  return {
    handleSortClick,
    sortBy,
    sortDirection,
  };
}

